// PARAQTA — формат утилиталары (HTML escape, сан, күн).
// Бұл функциялар бүкіл UI render қадамдарында қолданылады.

export function esc(s) {
  return String(s || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

export function fmtBig(n) {
  if (!n) return '0';
  if (n >= 1000000) return (n / 1000000).toFixed(n % 1000000 >= 100000 ? 1 : 0).replace('.', ',') + 'М+';
  if (n >= 10000)   return Math.floor(n / 1000) + 'К+';
  return n.toLocaleString();
}

export function fmtDate(s) {
  if (!s) return '';
  const d = new Date(s), now = new Date(), diff = Math.floor((now - d) / 60000);
  if (diff < 1) return 'Жаңа ғана';
  if (diff < 60) return diff + ' мин бұрын';
  if (diff < 1440) return Math.floor(diff / 60) + ' сағ бұрын';
  return d.toLocaleDateString('kk-KZ');
}
